import React from 'react'
import styled from '@emotion/styled'
import { BreakPoint } from 'src/components/shared/CssValues'
import { Typography } from 'src/components/atoms/Typography'

const Layout = styled(Typography)`
  text-align: left;
  line-height: 30px;

  h2 {
    font-size: 22px;
    font-weight: bold;
    line-height: 2;
    letter-spacing: 1.12px;
    color: #22475d;
    margin: calc(2.5em - 60px) 0 1.5em;
    padding-top: 60px;
    text-align: left;
    @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
      font-size: 18px;
      line-height: 1.5;
    }
  }

  p {
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2;
    letter-spacing: 1.12px;
    text-align: left;
    color: #333333;
    margin: 2em 0;
    @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
      font-size: 16px;
    }
  }

  strong {
    font-size: 16px;
    font-weight: bold;
    @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
      font-size: 16px;
    }
  }

  a {
    color: inherit;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }

  img {
    max-width: 100%;
  }

  blockquote {
    padding: 30px 40px;
    margin: 0;
    background-color: #eff7fc;

    p {
      margin: 0;
    }
  }

  #buttonTitle {
    color: #235776;
    font-size: 26px;
    font-weight: bold;
    padding-bottom: 20px;
    @media screen and (max-width: ${BreakPoint.SMARTPHONE_MAX_WIDTH}) {
      font-size: 20px;
    }
  }
  
  #ctaButton {
    background-color: #ef5e4b;
    color: #fff;
    border: none;
    cursor: pointer;
    padding: 10px 30px;
    border-radius: 30px;
    font-size: 26px;
    font-weight: bold;
    text-aline: center;
    box-shadow: 2px 2px 4px #808080;
  }




  
`

const BlogPostLayout = ({ html }) => (
  <Layout>
    <div dangerouslySetInnerHTML={{ __html: html }} />
  </Layout>
)

export default BlogPostLayout
